import { Grid, styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { Button } from "../../../../../Form";

export const useStyles = () =>
  makeStyles(() => ({
    panel: {
      border: "1px solid #E4E7EC !important",
      borderRadius: "8px !important",
      backgroundColor: "#F9FAFB !important",
      "& header": {
        backgroundColor: "#F9FAFB !important",
      },
      "& header > span": {
        width: "100% !important",
      },
    },
  }));

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  textAlign: "left",
  color: "#475467",
}));

export const CountBadge = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "16px",
  height: "16px",
  borderRadius: "100px",
  backgroundColor: "#475467",
  marginLeft: "6px",
  "& span": {
    fontFamily: "Manrope",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: "16px",
    color: "#fff",
  },
}));

export const MainContainer = styled(Grid)(() => ({}));

export const CollapseBody = styled("div")(() => ({}));

export const ButtonSection = styled(Grid)(() => ({
  borderTop: "1px solid #E4E7EC",
  height: "Hug (73px)",
  padding: "16px",
}));

export const AddContainerButton = styled(Button)(() => ({
  color: "#0055A4",
  "& svg": {
    color: "#0055A4",
  },
  "&:focus": {
    backgroundColor: "#0055A414",
    color: "#0055A4",
  },
  "&:hover": {
    backgroundColor: "#0055A414",
    color: "#0055A4",
  },
}));

export const Summary = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  backgroundColor: "#F2F4F7",
  border: "1px solid #E4E7EC",
  borderRadius: "8px",
  height: "Hug (44px)",
  marginRight: "24px",
  "& div": {
    display: "flex",
    flexDirection: "column",
    padding: "4px 12px 4px 12px",
    "&:not(:last-child)": {
      borderRight: "1px solid #E4E7EC",
    },
  },
  "& span": {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    color: "#667085",
  },
}));

export const Row = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const Divider = styled("span")(() => ({
  "&:not(:last-child)": {
    marginBottom: "16px",
    width: "100%",
    border: "1px solid #E4E7EC",
  },
}));

export const ContainerFragment = styled("div")(() => ({
  marginBottom: "16px",
}));
